<script>
	import * as Cards from "../../../resources/cards";

	export let card = "";
	export let small = false;
	export let width = 70;
	export let onCardLift = () => {};
	export let onCardDrop = () => {};

	const cardRatio = 336 / 240;
	const height =  width * cardRatio;

	let pageX = 0;
	let pageY = 0;
	let moving = false;
	let styleString = "";

	const onMouseDown = () => {
		moving = true;
		onCardLift(card);
	}

	const onMouseUp = () => {
		moving = false;
		styleString = "";

		onCardDrop(card, { pageX, pageY });
	}

	const handleMousemove = (event) =>  {
		if (!moving) {
			return;
		}

		({ pageX, pageY } = event.touches ? event.touches[0] : event);
		let translateX = pageX - width / 2;
		let translateY = pageY - height / 2;
		styleString = `
			position: absolute;
			top: ${translateY}px;
			left: ${translateX}px;
		`;
	}

	const stringMap = {
		"7": "7",
		"8": "8",
		"9": "9",
		"X": "10",
		"J": "B",
		"Q": "D",
		"K": "K",
		"A": "A",
		"D": "\u2666",
		"H": "\u2665",
		"S": "\u2660",
		"C": "\u2663",
	}
	const colorMap = {
		"D": "#FF0000",
		"H": "#FF0000",
		"S": "#000000",
		"C": "#000000",
	}

	$: smallArray = card.split("").map((char) => {
		return stringMap[char];
	}).reverse();

	$: color = colorMap[card[0]];
</script>

<div>
	{#if small}
		<div class="smallCard" style={`color: ${color}`}>
			<div>
				{smallArray[0]}
			</div>
			<div>
				{smallArray[1]}
			</div>
		</div>
	{:else}
		<div
			on:touchstart={onMouseDown}
			on:touchmove={handleMousemove}
			on:touchend={onMouseUp}
			on:mousedown={onMouseDown}
			on:mousemove={handleMousemove}
			on:mouseup={onMouseUp}
			style={styleString}>
			<svelte:component
				this={Cards[card]}
				{width}
				{height}
			/>
		</div>
	{/if}
</div>

<style>
	.smallCard {
		display: flex;
		flex-direction: column;
		align-items: center;

		width: 1em;
		line-height: 1em;
	    padding: 2px;
	    margin-right: 1px;

	    background-color: #ffffff;

		border-style: solid;
		border-radius: 3px;
		border-width: 1px;
		border-color: #000000;
	}
</style>